function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(-.069 .693)"
}, React.createElement("g", {
  fill: "#750C41"
}, React.createElement("path", {
  d: "M9.506 28.54h6.82v8.099h-6.82zM22.465 28.54h6.139v8.099h-6.14z"
})), React.createElement("path", {
  fill: "#EF378B",
  d: "M37.811 22.736c0 8.301-7.912 10.529-17.665 10.529-9.754 0-17.666-2.228-17.666-10.529 0-8.368 7.912-15.117 17.666-15.117 9.753 0 17.665 6.749 17.665 15.117z"
}), React.createElement("path", {
  fill: "#D61E69",
  d: "M37.811 23.276c0 7.896-7.912 9.989-17.665 9.989-9.754 0-17.666-2.093-17.666-9.989 0-7.896 7.912-14.308 17.666-14.308 9.753 0 17.665 6.412 17.665 14.308z"
}), React.createElement("path", {
  fill: "#C61867",
  d: "M37.811 22.736c.41 8.436-7.912 10.529-17.665 10.529-9.754 0-17.666-2.228-17.666-10.529"
}), React.createElement("path", {
  fill: "#EF378B",
  d: "M25.875 28.54h6.139v8.099h-6.139z"
}), React.createElement("g", {
  fill: "#D61E69",
  transform: "translate(1.36 5.77)"
}, React.createElement("path", {
  d: "M24.516 22.77h6.138v8.098"
}), React.createElement("ellipse", {
  cx: 9.851,
  cy: 20.947,
  rx: 8.662,
  ry: 5.534
}), React.createElement("path", {
  d: "M17.961 14.85c-1.922 2.373-6.498 1.955-10.25-.915-3.752-2.871-5.503-9.202-3.642-11.603C5.99-.04 10.772 2.279 14.556 5.24s5.266 7.21 3.405 9.61z"
})), React.createElement("path", {
  fill: "#EF378B",
  d: "M6.152 7.933c2.123-2.196 6.683.529 10.192 3.807 3.51 3.277 4.615 7.638 2.55 9.87"
}), React.createElement("ellipse", {
  cx: 2.549,
  cy: 24.154,
  fill: "#D61E69",
  rx: 2.387,
  ry: 4.387
}), React.createElement("ellipse", {
  cx: 1.594,
  cy: 24.154,
  fill: "#EF599D",
  rx: 1.432,
  ry: 4.387
}), React.createElement("ellipse", {
  cx: 1.389,
  cy: 23.951,
  fill: "#C61867",
  rx: 1,
  ry: 2.025
}), React.createElement("ellipse", {
  cx: 7.323,
  cy: 18.417,
  fill: "#63113A",
  rx: 1,
  ry: 1
}), React.createElement("ellipse", {
  cx: 7.187,
  cy: 18.147,
  fill: "#841E56",
  rx: 1,
  ry: 1
}), React.createElement("ellipse", {
  cx: 13.189,
  cy: 23.276,
  fill: "#EF378B",
  rx: 3.82,
  ry: 1.485
}), React.createElement("path", {
  fill: "#D61E69",
  d: "M40.335 21.791c0 .338-.273.675-.614.675h-5.389c-.34 0-.613-.337-.613-.675 0-.337.272-.674.613-.674h5.389c.34 0 .614.337.614.674z"
}), React.createElement("path", {
  fill: "#EF378B",
  d: "M27.99 11.398c0 1.822-2.593 3.307-5.866 3.307-3.206 0-5.866-1.485-5.866-3.307 0-1.822 2.592-3.307 5.866-3.307 3.205 0 5.865 1.485 5.865 3.307z"
}), React.createElement("path", {
  fill: "#D61E69",
  d: "M26.08 9.98c0 .203-.137.338-.273.338h-6.82c-.137 0-.274-.135-.274-.337 0-.203.137-.338.273-.338h6.82c.137 0 .274.135.274.338z"
}), React.createElement("path", {
  fill: "#63113A",
  d: "M26.08 10.656c0 .202-.137.337-.273.337h-6.82c-.137 0-.274-.135-.274-.337 0-.203.137-.338.273-.338h6.82c.137 0 .274.135.274.338z"
}), React.createElement("path", {
  fill: "#EF378B",
  d: "M12.916 28.54h6.139v8.099h-6.139z"
}), React.createElement("path", {
  fill: "#D61E69",
  d: "M12.916 28.54h6.138v8.099"
}), React.createElement("ellipse", {
  cx: 22.037,
  cy: 5.062,
  fill: "#B5750F",
  rx: 5.115,
  ry: 5.062
}), React.createElement("ellipse", {
  cx: 22.037,
  cy: 5.146,
  fill: "#DD981D",
  rx: 5.115,
  ry: 5.062
}), React.createElement("path", {
  fill: "#CE8106",
  d: "M22.037.084c2.831 0 5.115 2.26 5.115 5.062 0 2.802-2.284 5.062-5.115 5.062"
}), React.createElement("ellipse", {
  cx: 22.079,
  cy: 5.104,
  fill: "#EFB65B",
  rx: 3.282,
  ry: 3.248
}), React.createElement("path", {
  fill: "#E2A750",
  d: "M24.401 2.868a3.254 3.254 0 0 1 0 4.618 3.338 3.338 0 0 1-4.666 0"
}));

var SvgSavings = function SvgSavings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSavings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/savings.d3d70377.svg";
export { ForwardRef as ReactComponent };